import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private httpClient: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get all countries
   * @returns Array
   */
  getAllCountries(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/countries`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Create new country
   * @param formData
   * @returns array
   */
  save(formData:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/countries`;

    return this.httpClient.post(apiURL,formData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get country record for editing
   * @returns Array
   */
  edit(id:string){

    let apiURL:string=`${this.baseURL}/v1/countries/${id}/edit`;

    return this.httpClient.get(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update country record
   * @param formData
   * @param Id
   * @returns array
   */
  update(formData:any,Id: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/countries/${Id}`;

    return this.httpClient.put(apiURL,formData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

   /**
   * Delete country record
   * @param Id
   * @returns array
   */
   delete(Id: string|null):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/countries/${Id}`;

    return this.httpClient.delete(apiURL, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
